import React from 'react';
import PropTypes from 'prop-types';
import Menu from './components/Menu';
import { Wrapper } from './common-styled';

const Settings = ({ onClose }) => (
  <Wrapper>
    <Menu onClose={ onClose } />
  </Wrapper>
);

Settings.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default Settings;
